import { text as textWeb } from '@/apps/web/constants/text'
import { text as textDash } from '@/apps/dashboard/constants/text'

const textWebAdmisi = Object.assign({},
  textWeb,
  textDash
)
export default textWebAdmisi